__webpack_require__.p = "/jamming/";